import New from "./New";
import Edit from "./Edit";

export default {
  New,
  Edit
};
